import React from 'react'
import { Nav, NavItem, NavLink } from 'reactstrap'
import tapOrClick from 'react-tap-or-click'
import EditPlanIcon from 'react-icons/lib/fa/edit'
import AddPlanIcon from 'react-icons/lib/fa/plus-square'
import SubsListIcon from 'react-icons/lib/fa/list'
import classnames from 'classnames'
import '../../../stylesheets/ControllerDashboard.css'
import { authRedirect } from "../../../dataHelpers/authenticationHelpers"
import { AssignDiscount } from "../../ui"

class DiscountSetting extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            activeTab: '1',
            errors: []
        }
    }

    render() {

        return (<div>
            <div className="m-0 p-0">
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '1' })}
                        >
                            <AddPlanIcon />&ensp;Assign Discount
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '2' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/editassigneddiscount`, this.props.history)) })}
                        >
                            <EditPlanIcon />&ensp;Edit Assigned Discount
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '3' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/teamdiscountlist`, this.props.history)) })}>
                            <SubsListIcon />&ensp;Assigned Discount Levels
                            </NavLink>
                    </NavItem>
                </Nav>
            </div>
            <AssignDiscount />
        </div>)
    }
}
export default DiscountSetting



// WEBPACK FOOTER //
// ./src/components/pages/subscription/DiscountSetting.js